// 权限管理
const report = () => import(/* webpackChunkName: "ininCatorReport" */ '../../views/ininCatorReport/index'), //
    inCode = () => import(/* webpackChunkName: "ininCatorReport" */ '../../views/ininCatorReport/indexCopy');
export default [
    {
        path: '/ininCatorReport/report',
        name: 'report',

        meta: { title: '报表查询',selfFlg: 'report', },
        component: report
    },
    {
        path: '/ininCatorReport/inCode',
        name: 'inCode',

        meta: { title: '指标查询', selfFlg: 'target', },
        component: inCode
    }
];
